import { Component } from "react";
import { withRouter } from "../../../withRouter";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";

import Dashboard from "./pages/Dashboard";
import Campaigns from "./pages/Campaigns";
import NewCampaign from "./pages/NewCampaign";
import Outreach from "./pages/Outreach";
import OutreachNew from "./pages/OutreachNew";
import OutreachDetail from "./pages/OutreachDetail";
import Calendar from "./pages/Calendar";
import Customers from "./pages/Customers";
import CustomerDetail from "./pages/CustomerDetail";
import Templates from "./pages/Templates";
import TemplateEditor from "./pages/TemplateEditor";
import TemplatePreview from "./pages/TemplatePreview";
import Automations from "./pages/Automations";
import Analytics from "./pages/Analytics";
import Settings from "./pages/Settings";
import Unsubscribed from "./pages/Unsubscribed";

import { apiUrl, clientheaderconfig } from "../../Helpers/Config";
import axios from "axios";
import cookie from "react-cookies";
class EngagePlan extends Component {
  constructor(props) {
    super(props);
    const companyID = cookie.load("companyID") || "";
    this.state = {
      companyID: companyID,
      showAddOutlet: true,
    };
  }
  componentDidMount() {
    this.loadOutlet();
  }
  loadOutlet() {
    var urlShringTxt = apiUrl + "outlet/dropdown?company_id=" + this.state.companyID;
    axios
      .get(urlShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          /*   const result = res.data.result;
         const ids = result
  .filter(item =>
    typeof item?.outletsupabaseReservationOutletID === "string" &&
    item.outletsupabaseReservationOutletID.trim() !== ""
  )
  .map(item => item.outletsupabaseReservationOutletID);
          const emptyOrMissingCount = result.filter((item) => {
            const id = item?.outletsupabaseReservationOutletID;
            return id === null || id === undefined || (typeof id === "string" && id.trim() === "");
          }).length;
          this.setState({ outletList: result, loading: false, supabaseoutletIDs_: ids, showAddOutlet:emptyOrMissingCount>0?true:false }, () => {
            if (this.state.supabaseoutletIDs_.length === 0) {
              this.props.navigate("/clientpanel/reservation/settings");
            }
          }); */
        }
      })
      .catch();
  }
  onRecallOulet(recall) {
    if (recall === true) {
      this.loadOutlet();
    }
  }
  render() {
    const customerID = this.props.params?.id || "";
    const templatid = this.props.params?.templatid || "";
    const gtemplatid = this.props.params?.gtemplatid || "";
    const id = this.props.params?.id || "";
    console.log(this.props.location.pathname, this.props.params, "this.props.params");
    let currentPage = "enagev1-dashboard";
    if (this.props.location.pathname === "/clientpanel/enagev1/dashboard") {
      currentPage = "enagev1-dashboard";
    } else if (this.props.location.pathname === "/clientpanel/enagev1/campaigns") {
      currentPage = "enagev1-campaigns";
    } else if (this.props.location.pathname === "/clientpanel/enagev1/campaigns/new") {
      currentPage = "enagev1-campaigns-new";
    } else if (this.props.location.pathname === "/clientpanel/enagev1/outreach") {
      currentPage = "enagev1-outreach";
    } else if (this.props.location.pathname === "/clientpanel/enagev1/outreach/new") {
      currentPage = "enagev1-outreach-new";
    } else if (this.props.location.pathname.indexOf("/clientpanel/enagev1/outreach/") >= 0 && id !== "") {
      currentPage = "enagev1-outreach-details";
    } else if (this.props.location.pathname === "/clientpanel/enagev1/calendar") {
      currentPage = "enagev1-calendar";
    } else if (this.props.location.pathname === "/clientpanel/enagev1/customers") {
      currentPage = "enagev1-customers";
    } else if (this.props.location.pathname.indexOf("/clientpanel/enagev1/customers/") >= 0 && id !== "") {
      currentPage = "enagev1-customers-details";
    } else if (this.props.location.pathname === "/clientpanel/enagev1/templates") {
      currentPage = "enagev1-templates";
    } else if (this.props.location.pathname === "/clientpanel/enagev1/templates/new") {
      currentPage = "enagev1-templates-new";
    } else if (this.props.location.pathname.indexOf("/clientpanel/enagev1/templates/") >= 0 && this.props.location.pathname.indexOf("/edit") >= 0 && id !== "") {
      currentPage = "enagev1-templates-edit";
    } else if (this.props.location.pathname.indexOf("/clientpanel/enagev1/templates/") >= 0 && this.props.location.pathname.indexOf("/preview") >= 0 && id !== "") {
      currentPage = "enagev1-templates-preview";
    } else if (this.props.location.pathname === "/clientpanel/enagev1/automations") {
      currentPage = "enagev1-automations";
    } else if (this.props.location.pathname === "/clientpanel/enagev1/analytics") {
      currentPage = "enagev1-analytics";
    } else if (this.props.location.pathname === "/clientpanel/enagev1/settings") {
      currentPage = "enagev1-settings";
    } else if (this.props.location.pathname === "/clientpanel/enagev1/unsubscribed") {
      currentPage = "enagev1-unsubscribed";
    }
    
    console.log(this.props.location.pathname.indexOf("/clientpanel/enagev1/templates/"), this.props.location.pathname.indexOf("/edit"), id, currentPage, 'idididididid')
    return (
      <div className="layout-wrapper layout-content-navbar reservation-main ">
        <div className="layout-container engage-main engage-v1">
          <Header {...this.props} currentPage={currentPage} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="card fv-plugins-bootstrap5">
                <div className="subcontent-enagev1 card-body row g-3">
                  <div className="flex-grow-1">
                    {currentPage === "enagev1-dashboard" && <Dashboard />}
                    {currentPage === "enagev1-campaigns" && <Campaigns />}
                    {currentPage === "enagev1-campaigns-new" && <NewCampaign />}
                    {currentPage === "enagev1-outreach" && <Outreach />}
                    {currentPage === "enagev1-outreach-new" && <OutreachNew />}
                    {currentPage === "enagev1-outreach-details" && <OutreachDetail />}
                    {currentPage === "enagev1-calendar" && <Calendar />}
                    {currentPage === "enagev1-customers" && <Customers />}
                    {currentPage === "enagev1-customers-details" && <CustomerDetail />}
                    {currentPage === "enagev1-templates" && <Templates />}
                    {currentPage === "enagev1-templates-new" && <TemplateEditor />}
                    {currentPage === "enagev1-templates-edit" && <TemplateEditor />}
                    {currentPage === "enagev1-templates-preview" && <TemplatePreview />}
                    {currentPage === "enagev1-automations" && <Automations />}
                    {currentPage === "enagev1-analytics" && <Analytics />}
                    {currentPage === "enagev1-settings" && <Settings />}
                    {currentPage === "enagev1-unsubscribed" && <Unsubscribed />}
                    
                  </div>
                </div>
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>

        <div className="drag-target"></div>
      </div>
    );
  }
}

export default withRouter(EngagePlan);
